module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "xgzl-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "xgzl-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xgzl-box-model-top"
  }, [_c('div', {
    staticClass: "xgzl-box-model-top-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xiugaiziliao')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/wode_jiazu@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xgzl-box-model-img"
  }, [_c('img', {
    staticClass: "xgzl-box-model-img-img",
    attrs: {
      "src": _vm.form.headPortrait,
      "alt": ""
    },
    on: {
      "click": _vm.handleUploadClick
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xgzl-box-model-img-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nickName),
      expression: "form.nickName"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.form.nickName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "nickName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xgzl-box-model-btn"
  }, [_c('div', {
    staticClass: "xgzl-box-model-bottom",
    on: {
      "click": _vm.updUserInfo
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiao')))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b27b721"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiugaiziliao/xiugaiziliao.vue
// module id = 794
// module chunks = 1